import React, { Fragment, useEffect, useState } from 'react'

import { breakpointPx } from '../../helpers/ContentHelper'
import PageSkeleton from '../../components/Skeletons/PageSkeleton'
import * as Styled from './HomepageComponents.styles'

const HomepageComponents = ({ homepageData, onCmsClick, isResettingData }) => {
  const [heroImgWidth, setHeroImageWidth] = useState('545')
  useEffect(() => {
    const isInBetween = window.innerWidth >= breakpointPx.SMALL && window.innerWidth <= breakpointPx.LARGE
    if (isInBetween) setHeroImageWidth(window.innerWidth.toString())
  }, [])

  if (isResettingData) return <PageSkeleton page={'homepage'} />
  if (!homepageData?.data) return <Fragment />

  const componentBlockOne = () => {
    const homepageComponents = []
    homepageData.data.map((component, index) => {
      if (index >= 9) return null
      const mobileImgWidth = index === 2 || index === 3 || index === 6 || index === 7 ? '379' : heroImgWidth
      const {
        type,
        linkUrl,
        linkTitle,
        imageURL,
        altText,
        proposition,
        heading,
        subheading,
        linkTarget = '_self',
        cta,
      } = component
      return homepageComponents.push(
        <Styled.Component
          data-test={type}
          index={index + 1}
          onClick={(event) => linkTarget !== '_blank' && onCmsClick(event, linkUrl)}
          href={linkUrl}
          title={linkTitle}
          target={linkTarget}
          key={`${linkTitle}-${index}`}>
          {type === 'proposition' ? (
            <Styled.Proposition hidden={!proposition.length}>
              <Styled.PropositionText>{proposition}</Styled.PropositionText>
            </Styled.Proposition>
          ) : imageURL ? (
            <Styled.ImageContainer>
              <Styled.StyledImage src={imageURL} alt={altText} width={mobileImgWidth} />
            </Styled.ImageContainer>
          ) : (
            <Styled.TextComponent>
              <Styled.TextContent>
                <h3>{heading}</h3>
                <p>{subheading}</p>
                <Styled.CTA>{cta}</Styled.CTA>
              </Styled.TextContent>
            </Styled.TextComponent>
          )}
        </Styled.Component>,
      )
    })
    return homepageComponents
  }

  const componentBlockTwo = () => {
    const homepageComponents = []
    homepageData.data.map((component, index) => {
      if (index <= 8) return null
      const { type, linkUrl, linkTitle, imageURL, altText, linkTarget = '_self' } = component

      return homepageComponents.push(
        <Styled.Component
          data-test={`${type}-${index}`}
          index={index + 1}
          onClick={(event) => linkTarget !== '_blank' && onCmsClick(event, linkUrl)}
          href={linkUrl}
          target={linkTarget}
          title={linkTitle}
          key={`${linkTitle}-${index}`}>
          <Styled.StyledImage data-test={linkTitle} src={imageURL} alt={altText} width='767' lazy />
        </Styled.Component>,
      )
    })
    return homepageComponents
  }
  return (
    <Fragment>
      <Styled.Container columns={4}>{componentBlockOne()}</Styled.Container>
      <Styled.Container columns={3}>{componentBlockTwo()}</Styled.Container>
    </Fragment>
  )
}

export default HomepageComponents
